export enum PromotionTargetTypeEnum {
    ALL = "all",           // Tous les produits de l'organisation
    CATEGORIES = "categories", // Catégories spécifiques
    PRODUCTS = "products",   // Produits spécifiques
};
